/**
 * @ngdoc controllers
 * @memberof mercury.modules.reports.sales.worksheet
 * @name SalesWorksheetCtrl
 * @description Daily sales worksheet to allow the editing of food and beverage sales for a day, used by customers without a POS integration.
 */
angular.module('mercury.modules.reports.sales.worksheet')
.controller('SalesWorksheetCtrl', ["ManualPosSales", "dialog", "$q", "reporttime", "ReportSales", "$scope", "$state", "$stateParams", "title", function(ManualPosSales, dialog, $q, reporttime, ReportSales, $scope, $state, $stateParams, title) {
  title.set('Sales Worksheet');
  reporttime.setAllowedTypes(['month']);

  // the start and end times here need to match the time that we insert the
  // records into the db as, that is at <day> 23:59:00
  var startTime = moment(reporttime.start()).mStartOf('week').endOf('day').seconds(0).format();
  var endTime = moment(reporttime.end()).mStartOf('week').endOf('day').seconds(0).add(1, 'week').format();

  $scope.loading = $q.all({
    sales: ManualPosSales.getMonth(reporttime.time())
  });

  $scope.loading.then(function(results) {
    var sales = results.sales;

    //map the budget into an hash
    var salesByStartTime = {};
    angular.forEach(sales, function(sale) {
      salesByStartTime[moment(sale.saleTime).endOf('day').seconds(0).format()] = sale;
    });

    // initialize an array of week start dates for formatting purposes
    $scope.weeks = [];
    for (
      var weekStartDate = moment(startTime);
      weekStartDate < moment(endTime);
      weekStartDate = weekStartDate.add(7, 'days')
    ) {
      var week = {
        days: [],
        foodAmountTotal: 0,
        beverageAmountTotal: 0
      };

      for (var i = 0; i < 7; i++) {
        var dayStart = moment(weekStartDate).add(i, 'days');

        var daysSales;
        if (salesByStartTime[dayStart.format()]) {
          daysSales = salesByStartTime[dayStart.format()];
        } else {
          daysSales = {
            saleTime: dayStart.clone().endOf('day').seconds(0).add(1, 'day').format(),
            foodAmount: 0,
            beverageAmount: 0
          };
        }

        var inMonth = moment(weekStartDate).add(i, 'days') >= moment(reporttime.start()) && moment(weekStartDate).add(i, 'days') < moment(reporttime.end());

        week.days.push({
          id: daysSales.id,
          saleTime: dayStart.format(),
          dbSaleTime: dayStart,
          inMonth: inMonth,
          foodAmount: daysSales.foodAmount,
          beverageAmount: daysSales.beverageAmount,
          totalAmount: parseFloat(daysSales.foodAmount) + parseFloat(daysSales.beverageAmount)
        });

        week.foodAmountTotal += parseFloat(daysSales.foodAmount);
        week.beverageAmountTotal += parseFloat(daysSales.beverageAmount);
      }

      $scope.weeks.push(week);
    }
  });

  /**
   * Safely updates the F&B totals in a week object.
   */
  function recalculateWeeklyTotal(week) {
    var foodTotal = 0;
    var beverageTotal = 0;
    angular.forEach(week.days, function(weekday) {
      foodTotal += parseFloat(weekday.foodAmount);
      beverageTotal += parseFloat(weekday.beverageAmount);
    });
    week.foodAmountTotal = foodTotal;
    week.beverageAmountTotal = beverageTotal;
  }

  $scope.updateFood = function(day, week) {
    if ($scope.inputForm['foodAmount' + day.saleTime].$invalid) {
      return;
    }

    day.totalAmount = parseFloat(day.foodAmount) + parseFloat(day.beverageAmount);
    recalculateWeeklyTotal(week);
    day.savingFood = true;

    ManualPosSales.update(day)
    .then(function(result) {
      if (!day.id) {
        day.id = result.id;
      }

      day.foodAmount = result.foodAmount;
      day.beverageAmount = result.beverageAmount;

      day.error = false;
      day.saved = true;
      day.savingFood = false;

    }, function() {
      day.error = true;
      day.saved = false;
      day.savingFood = false;
    });
  };

  $scope.updateBeverage = function(day, week) {
    if ($scope.inputForm['beverageAmount' + day.saleTime].$invalid) {
      return;
    }

    day.totalAmount = parseFloat(day.foodAmount) + parseFloat(day.beverageAmount);
    recalculateWeeklyTotal(week);
    day.savingBeverage = true;

    ManualPosSales.update(day)
    .then(function(result) {
      if (!day.id) {
        day.id = result.id;
      }

      day.foodAmount = result.foodAmount;
      day.beverageAmount = result.beverageAmount;

      day.error = false;
      day.saved = true;
      day.savingBeverage = false;

    }, function() {
      day.error = true;
      day.saved = false;
      day.savingBeverage = false;
    });
  };

}]);
